import React from 'react'

import Mark from './Mark'

// The house header — nodejavascript.com site standard, part 3.
//
// 🔴 THE RULE IS THAT IT LOOKS LIKE THE REFERENCE BAR, WITH NOTHING ON THE RIGHT.
// George, 19 September 2026, verbatim: *"the rule for header is that it should look like
// http://127.0.0.1:4330/ but without the More detail link"*. Taken literally, that page's header
// is the brand plus ONE nav link — so removing the link leaves the brand and nothing else. The
// header is not a place for navigation; the brand is the door home and the page is one page.
//
// The bar itself is part 3: full width, sticky, its own near-black showing through a blur, a
// hairline underneath, the shared mark at the left, the site's name over nodejavascript.com in
// small capitals. The name is the site's own (the host's first label), as on every sibling.
// 🔴 AND THE BRAND GOES TO THIS SITE, NOT TO nodejavascript.com. George, 19 September 2026,
// verbatim: *"new rule for header when clicking on the top left site name and icon, it should go
// to self, not nodejavascript.com"*. Pressing the name of the site you are already on should
// keep you on it — the way home is the footer's brand line (part 4), which is where the
// mother-site link is required.
const SiteHeader = () => {
  return (
    <header className='dvs-header'>
      <a className='dvs-brand' href='/'>
        <span className='dvs-mark' aria-hidden='true'>
          <Mark size={24} />
        </span>
        <span className='dvs-brand-text'>
          <b>password-please</b>
          <small>nodejavascript.com</small>
        </span>
      </a>
    </header>
  )
}

export default SiteHeader
